import { CODE_ENV, CURRENT_CODE_ENV } from "./constant";

/**
 * 解析URL参数为对象
 * @param url 可选，默认使用当前页面URL（仅在浏览器环境）
 * @returns 参数键值对对象
 */
export const getUrlParams = (url?: string): Record<string, string> => {
  // 如果没有传入 url，尝试从 window.location 获取（仅在浏览器环境）
  if (!url) {
    if (typeof window !== 'undefined' && window.location) {
      url = window.location.href;
    } else {
      // SSR 环境下，如果没有传入 url，返回空对象
      return {};
    }
  }
  
  if (!url) return {};
  
  // 提取 URL 中的查询参数部分
  const queryString = url.split('?')[1];
  if (!queryString) return {};
  
  const params = new URLSearchParams(queryString);
  return Object.fromEntries(params.entries());
};

/**
 * 获取单个URL参数值
 * @param key 参数名
 * @param url 可选URL
 */
export const getUrlParam = (key: string, url?: string): string | null => {
  return getUrlParams(url)[key] || null;
};

/**
 * 补充参数到URL
 * @param url 原始URL
 * @param params 参数对象
 * @returns 补充后的URL
 */
export const appendUrlParams = (url: string, params: Record<string, string>): string => {
  const urlParams = getUrlParams(url);
  const mergedParams = { ...urlParams, ...params };
  const queryString = new URLSearchParams(mergedParams).toString();
  
  // 获取基础 URL（去掉查询参数部分）
  const baseUrl = url.split('?')[0];
  return `${baseUrl}?${queryString}`;
};

export const appendQuanquanSTParams = (params: Record<string, string>): Record<string, string> => {
  if (CURRENT_CODE_ENV === CODE_ENV.STAGING) {
    return {
      ...params,
      gray_test: 'webstatic_gray_test',
      _ssr_open_: '0',
    }
  } else {
    return params;
  }
};

// ============================================
// 参数对象按 key 列表取值
// ============================================

/**
 * 从 record 中按 keys 顺序取第一个非空（trim 后）值
 */
export function getFirstValue(
  record: Record<string, string | undefined> | null | undefined,
  keys: readonly string[],
): string | undefined {
  if (!record) return undefined;
  for (const key of keys) {
    const v = record[key]?.trim();
    if (v) return v;
  }
  return undefined;
}
